import { isSubscriptionActive } from "../common";

/** Returns true when the user has an active membership/subscription. */
export const hasActiveMembership = (user) => isSubscriptionActive(user);

/**
 * Resolve a member-only WordPress SSO URL from the Redux user object.
 * @param {object} user
 * @param {'searchUrl'|'bookConsultUrl'} urlKey
 */
export const getMemberWordPressUrl = (user, urlKey) => {
  const url = user?.[urlKey];
  return url && String(url).trim() ? String(url).trim() : null;
};
